import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptorService implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
        let authResponse = JSON.parse(sessionStorage.getItem("authResponse"));
        let domainUrl=localStorage.getItem('domainUrl');
        if (authResponse && currentUser && currentUser.sessionToken) {
            request = request.clone({
                setHeaders: { 
                    'Accept':'application/json',
                    'access-token': ` ${currentUser.sessionToken}`,
                    'instance':` ${domainUrl}`,
                    'auth_token':` ${authResponse.token}`
                }
            });
        }else{
            request = request.clone({
                setHeaders: { 
                     'Accept':'application/json',
                    'instance':` ${domainUrl}`
                }
            });
        }

        return next.handle(request);
    }
    
}



// WEBPACK FOOTER //
// D:/Laxmi/angular/forms/XpressForms/src/app/jwt-interceptor.service.ts